export interface ContactHandoff {
  name: string;
  email: string;
  phone?: string;
  t: number;
}

const HANDOFF_MAX_AGE_MS = 30 * 60 * 1000;

function fromBase64Url(value: string): string {
  const base64 = value.replace(/-/g, '+').replace(/_/g, '/');
  const padded = base64 + '='.repeat((4 - (base64.length % 4)) % 4);
  const binary = atob(padded);
  try {
    return decodeURIComponent(escape(binary));
  } catch {
    return binary;
  }
}

export function parseContactHandoff(token: string): ContactHandoff | null {
  try {
    const decoded = fromBase64Url(token);
    const payload = JSON.parse(decoded) as ContactHandoff;
    if (!payload.email || !payload.t) return null;
    if (Date.now() - payload.t > HANDOFF_MAX_AGE_MS) return null;
    return {
      name: (payload.name || '').trim(),
      email: payload.email.trim(),
      phone: (payload.phone || '').trim() || undefined,
      t: payload.t,
    };
  } catch {
    return null;
  }
}
